import React, { useState, useEffect } from "react";
import { getData, postData } from "../api/protectedApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SettingLayout from "../component/layout/SettingLayout";
import OtpModalForm from "../component/ui/OtpModalForm";
import { formatHash, formatDate } from "../utils/tableUtils";
import { handleCopy } from "../utils/handleCopy";
import layoutStyles from "../component/layout/css/settingLayout.module.css";
import { callDataByEndpoint } from "../utils/dataUtils";

const ApiKey = () => {
  const [keysList, setKeysList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [copiedText, setCopiedText] = useState(null);

  const fetchKeys = () => {
    callDataByEndpoint("/user/get_api_keys", {
      method: "GET",
      setData: setKeysList,
    });
  };

  useEffect(() => {
    fetchKeys();
  }, []);

  const handleForm = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    try {
      setLoading(true);
      const response = await postData("/user/generate_api_key", { otp: otp });

      if (response.data.success) {
        toast.success(response.data.message || "API Key Generated Successfully");
        setShowModal(false);
        setOtp("");
        fetchKeys();
      } else {
        toast.error(response.data.message || "Failed to generate API Key");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while processing the request.");
    } finally {
      setLoading(false);
    }
  };

  const handleGetOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await getData("/user/withrawOtp", {});

      if (response.data.success) {
        toast.success("OTP Sent Successfully!");
        setOtpTimer(120);
      } else {
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error sending OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    if (otpTimer > 0) {
      timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpTimer]);

  const columns = [
    { key: "id", label: "ID" },
    { key: "apiKey", label: "API KEY" },
    { key: "apiSecret", label: "API SECRET" },
    { key: "date", label: "DATE" },
  ];

  const modalBody = (
    <OtpModalForm
      subtext="Enter the 6-digit OTP code sent to your registered contact to generate new production API keys."
      otp={otp}
      setOtp={setOtp}
      otpLoading={otpLoading}
      otpTimer={otpTimer}
      onGetOtp={handleGetOtp}
      onSubmit={handleForm}
      loading={loading}
      submitText="Confirm & Generate Key"
      submitLoadingText="Generating..."
    />
  );

  return (
    <SettingLayout
      heading="API Keys Management"
      subheading="Generate and manage secure credentials for gateway API integrations."
      buttonText="Create New Key"
      onAddClick={() => setShowModal(true)}
      cardTitle="API Keys Registry"
      cardSubtitle="Active production & sandbox access keys"
      columns={columns}
      table_data={keysList}
      emptyMessage="No API Keys Found."
      showModal={showModal}
      onCloseModal={() => setShowModal(false)}
      modalTitle="Generate New API Key"
      modalBody={modalBody}
    />
  );
};

export default ApiKey;
